import React from 'react';
import Divider from '@material-ui/core/Divider';
import KeyFinancial from 'src/common-ui/components/Macros/KeyFinancial/KeyFinancial';
import { StyledAccordion } from 'src/components/StyledAccordion/StyledAccordion';
import { MacrosAccordionProps } from 'src/common-ui/components/Macros/Macros.types';
import { keyFinancialsContainer } from './KeyFinancial.styles';

export const KeyFinancialsAccordion = ({
  dataLoaded,
  macros,
  overrideTransition = false,
}: Omit<MacrosAccordionProps, 'onToggleAccordion'>) => {
  return (
    <StyledAccordion expanded={true} title="Key Financials" overrideTransition={overrideTransition}>
      <div data-qa="key-financials" className={keyFinancialsContainer}>
        {macros.map((item, i, arr) => {
          const isLastItem = i === arr.length - 1;
          return (
            <React.Fragment key={i}>
              <KeyFinancial {...item} key={i} dataLoaded={dataLoaded} />
              {isLastItem ? null : <Divider orientation="vertical" flexItem={true} />}
            </React.Fragment>
          );
        })}
      </div>
    </StyledAccordion>
  );
};
